export function StatStrip({ metrics = [] }) {
  if (!metrics || metrics.length === 0) return null;
  return (
    <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-hair bg-hair md:grid-cols-4" data-testid="trust-strip">
      {metrics.map((m, i) => (
        <div key={i} className="bg-white p-6 text-center">
          <p className="font-heading text-3xl font-bold text-navy">{m.value}</p>
          <p className="mt-1 text-xs uppercase tracking-wide text-subtle">{m.label}</p>
        </div>
      ))}
    </div>
  );
}
